module.exports = __webpack_public_path__ + "static/img/books-stack-of-three-green.b63e1a2c.svg";